export const salesCards = {
    contactInvoiceCard: {
        entity: 'invoice',
        path: 'invoice',
        titleBar: { mergeParams: ['number'], new: 'invoice.form.new.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'contactInvoiceCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'invoiceConfirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'invoiceConfirmBook',
                    modalPreflight: 'invoicePreBook'
                }
            ],
            actions: {
                book: { message: 'invoice.action.book.message' }
            }

        },
        width: '',
        fieldsLogic: ['paymentTermId', 'date', 'paymentDate'],
        defaultData: [
            {
                id: 'font',
                defaultType: 'value',
                defaultValue: 'Courier',
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'invoice',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.payments',
                            action: 'showModal',
                            icon: 'money',
                            modalFormRef: 'invoicePayments'
                        },
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        },
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.options',
                            action: 'showModal',
                            icon: 'gear',
                            modalFormRef: 'invoiceOptions'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'invoice.number',
                meta: {
                    type: 'form',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'invoice.form.number',
                                placeholder: 'invoice.form.number.placeholder',
                                entity: 'invoice',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'invoice.form.date',
                                placeholder: 'invoice.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate', 'exchangeRate', 'currency'],
                                align: 'right'
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'paymentTermIdDate',
                        fields: [
                            {
                                type: 'select',
                                id: 'paymentTermId',
                                displayField: 'paymentTermId',
                                label: 'invoice.form.paymentTerm',
                                entity: 'paymentTerm',
                                valueMap: {
                                    'paymentTermId': 'id',
                                    'paymentTermName': 'name',
                                    'paymentTermDays': 'days',
                                    'paymentSchedule': 'paymentSchedule',
                                    'paymentInstallments': 'installments',
                                    'paymentIntervalDays': 'intervalDays',
                                    'customPayments': 'customPayments'
                                },
                                nullDefaults: {
                                    'paymentSchedule': false,
                                    'paymentInstallments': 0,
                                    'paymentIntervalDays': 0,
                                    'customPayments': false
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate', 'numPayments', 'totalGrossSalesAmount', 'id']
                            },
                            {
                                type: 'date',
                                id: 'paymentDate',
                                label: 'invoice.form.paymentDate',
                                placeholder: 'invoice.form.paymentDate.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate']
                            },
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'message',
                        label: 'invoice.form.message',
                        placeholder: 'invoice.form.message.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'contactInvoiceCard.number.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'invoice.form.number.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'invoice.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoice.customer',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'dualconnect',
                        id: 'customerId',
                        displayField: 'customerName',
                        label: 'invoice.form.customerName',
                        placeholder: 'invoice.form.customerName.placeholder',
                        modalTitle: 'invoice.form.customer.modal.title',
                        entity: 'contact',
                        entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                        valueMap: {
                            'customerName': 'name',
                            'customerId': 'id',
                            'customerEmail': 'email',
                            'customerAddress_city': 'address_city',
                            'customerAddress_postCode': 'address_postCode',
                            'customerAddress_street': 'address_street',
                            'customerCountry': 'country',
                            'customerCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId',
                            'vatId': 'vatId',
                            'vatIdStatus': 'vatIdStatus',
                            'vatIdCheckedAt': 'vatIdCheckedAt',
                            'vatIdName': 'vatIdName',
                            'vatIdAddress': 'vatIdAddress',
                            'customerGroup': 'customerGroup',
                            'currency': 'currency',
                            'currencyName': 'currencyName',
                            'language': 'language',
                            'languageName': 'languageName',
                            'priceListId': 'priceListId',
                            'priceListName': 'priceListName'
                        },
                        // A customer without a VAT ID must not inherit the previous customer's check
                        nullDefaults: {
                            'vatId': '',
                            'vatIdStatus': 'unchecked',
                            'vatIdCheckedAt': null,
                            'vatIdName': null,
                            'vatIdAddress': null
                        },
                        options: { withHeaders: false },
                        required: true,
                        showSubField: { field: 'companyTypeId', value: 'company' },
                        sub: {
                            id: 'contactPersonId',
                            displayField: 'contactPersonName',
                            placeholder: 'invoice.form.contactPerson.name.placeholder',
                            modalTitle: 'invoice.form.contactPerson.modal.title',
                            entity: 'contactPerson',
                            valueMap: {
                                'contactPersonName': 'name',
                                'contactPersonId': 'id',
                                'customerEmail': 'email'
                            }
                        }
                    },
                    {
                        type: 'email',
                        id: 'customerEmail',
                        label: 'invoice.form.customerEmail',
                        placeholder: 'invoice.form.customerEmail.placeholder',
                        required: true
                    },
                    /*
                     * The customer's EU VAT ID and its VIES check. Reverse charge
                     * (0% EU) is the default, and can be booked, only when valid.
                     */
                    {
                        type: 'vatChecker',
                        id: 'vatId',
                        label: 'invoice.form.vatId',
                        placeholder: 'invoice.form.vatId.placeholder',
                        condition: { field: 'companyTypeId', operator: 'notEquals', value: 'person' }
                    },
                    {
                        type: 'text',
                        id: 'customerAddress_street',
                        label: 'invoice.form.customerAddress',
                        placeholder: 'invoice.form.customerAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'customerAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'customerAddress_postCode',
                                placeholder: 'invoice.form.customerAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'customerAddress_city',
                                placeholder: 'invoice.form.customerAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            },

                        ]
                    },
                    {
                        type: 'country',
                        id: 'customerCountry',
                        displayField: 'customerCountryName',
                        placeholder: 'invoice.form.customerCountry',
                        valueMap: {
                            'customerCountry': 'id',
                            'customerCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    },

                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'contactInvoiceCard.customer.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'customerName',
                    emptyMessage: 'invoice.form.customer.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoice.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'invoice.form.line.add.item',
                    width: '1200px',
                    menuTitle: 'all.form.line.menu',
                    menuItems: [
                        {
                            action: 'addLineDiscount',
                            label: 'all.form.line.discount.add',
                            condition: { field: 'discountType', operator: 'empty' }
                        },
                        {
                            action: 'removeLineDiscount',
                            label: 'all.form.line.discount.remove',
                            condition: { field: 'discountType', operator: 'notEmpty' }
                        }
                    ]
                },
                groups: [
                    {

                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'invoice.form.itemName',
                        placeholder: 'invoice.form.itemName.placeholder',
                        modalTitle: 'invoice.form.item.modal.title',
                        entity: 'product',
                        entityParams: {
                            name: 'priceList',
                            fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                        },
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'itemType': 'type',
                            'netSalesPrice': 'netSalesPrice',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                            'itemTaxId': 'taxId',
                            'itemTaxName': 'taxName',
                            'itemTaxRate': 'taxRate'
                        },
                        nullDefaults: { itemTaxRate: 0 },
                        options: { withHeaders: true },
                        required: true,
                        conditionalFields: {
                            fields: ['itemTaxId', 'itemTaxName', 'itemTaxRate'],
                            condition: { field: 'customerCountry', operator: 'equals', valueFrom: 'profile.currentOrgCountry' }
                        },
                        linkedFields: ['currency', 'campaignId', 'customerGroupId', 'priceListId']
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'invoice.form.itemDescription',
                        placeholder: 'invoice.form.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'netSalesPriceItemTaxId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'invoice.form.netPrice',
                                placeholder: 'invoice.form.netPrice',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'price'
                            },
                            {
                                type: 'select',
                                id: 'itemTaxId',
                                displayField: 'itemTaxName',
                                label: 'product.form.vatTax',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'vatTax',
                                entityParams: {
                                    type: 'query',
                                    params: [
                                        { key: 'scope', value: 'sales' },
                                        { key: 'recipientLocation', value: '${customerCountry}' },
                                        // The document date: the codes, and OSS from its registration date, as of then.
                                        { key: 'date', value: '${date}' },
                                        { key: 'companyType', value: '${companyTypeId}' },
                                        { key: 'productType', value: '${itemType}' },
                                        { key: 'requireValidVatId', value: 'true' },
                                        { key: 'vatIdStatus', value: '${vatIdStatus}' }
                                    ]
                                },
                                valueMap: {
                                    'itemTaxName': 'name',
                                    'itemTaxId': 'id',
                                    'itemTaxRate': 'rate',
                                    'itemTaxRequiresVatId': 'requiresVatId'
                                },
                                // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                                nullDefaults: { itemTaxRate: null },
                                options: { withHeaders: false },
                                required: true,
                                linkedFields: ['customerCountry', 'companyTypeId', 'vatIdStatus', 'date'],
                                lineLinkedFields: ['itemType']
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'invoice.form.itemQuantity',
                                placeholder: 'invoice.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'invoice.form.unitName',
                                placeholder: 'invoice.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },

                    /*
                     * Revealed by the line's own menu, which is what writes
                     * discountType. Both fields test the line rather than the
                     * document -- the scope B3 fixed -- so discounting one line
                     * does not put the fields on every other line.
                     */
                    {
                        type: 'group',
                        id: 'discountTypeDiscountValue',
                        condition: { field: 'discountType', operator: 'notEmpty' },
                        focus: false,
                        fields: [
                            {
                                type: 'switchSelect',
                                id: 'discountType',
                                displayField: 'discountTypeName',
                                label: 'all.form.line.discount.type',
                                entity: 'discountType',
                                valueMap: {
                                    'discountType': 'id',
                                    'discountTypeName': 'name'
                                }
                            },
                            {
                                type: 'number',
                                id: 'discountValue',
                                label: 'all.form.line.discount.value',
                                placeholder: 'all.form.line.discount.value.placeholder',
                                decimals: 2,
                                variant: 'price'
                            }
                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'contactInvoiceCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'contactInvoiceCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    // The currency rides with the figure rather
                                    // than dropping to its own line, which is
                                    // what makes room for the discount below.
                                    decorator: 'currency'
                                },
                                /*
                                 * What was taken off, under what was charged.
                                 * A percentage shows the rate and a fixed
                                 * discount shows the money, because those are
                                 * the two different things a reader wants back:
                                 * "(-10%)" or "(-1.000,00)".
                                 */
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.pct.display',
                                    mergeParams: ['discountValue'],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'percentage' }
                                },
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.amount.display',
                                    mergeParams: [{ type: 'amount', value: 'discountAmount' }],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'amount' }
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'invoice.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent',
                    menuTitle: 'all.form.total.menu',
                    menuItems: [
                        {
                            action: 'addDocumentDiscount',
                            label: 'all.form.total.discount.add',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'empty' }
                        },
                        {
                            action: 'editDocumentDiscount',
                            label: 'all.form.total.discount.edit',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            action: 'removeDocumentDiscount',
                            label: 'all.form.total.discount.remove',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        }
                    ]
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'all.form.field.vatPct',
                            labelParams: [['vatTaxRate', 100], 'vatTaxableAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'invoice.terms',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'textarea',
                        id: 'terms',
                        label: 'invoice.form.terms',
                        placeholder: 'invoice.form.terms.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'contactInvoiceCard.terms.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'terms',
                    emptyMessage: 'invoice.form.terms.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'invoice.form.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },

    creditNoteCard: {
        entity: 'creditNote',
        path: 'creditNote',
        titleBar: { mergeParams: ['number'], new: 'creditNote.form.new.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    id: 'creditNoteCard.save',
                    action: 'save',
                    label: 'all.menu.item.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false,
                    modalConfig: 'creditNoteConfirmSave'
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'invoiceConfirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'invoiceConfirmBook',
                    modalPreflight: 'invoicePreBook'
                },
            ],
            actions: {
                book: { message: 'invoice.action.book.message' }
            }

        },
        width: '',
        afterSubmit: { navigateTo: '/sales/creditNote' },
        fieldsLogic: ['paymentTermId', 'date', 'paymentDate'],
        defaultData: [
            {
                id: 'font',
                defaultType: 'value',
                defaultValue: 'Courier',
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'invoice',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.payments',
                            action: 'showModal',
                            icon: 'money',
                            modalFormRef: 'invoicePayments'
                        },
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        },
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.options',
                            action: 'showModal',
                            icon: 'gear',
                            modalFormRef: 'invoiceOptions'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'creditNote.number',
                meta: {
                    type: 'form',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'document.form.number',
                                placeholder: 'invoice.form.number.placeholder',
                                entity: 'invoice',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'document.form.date',
                                placeholder: 'invoice.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate'],
                                align: 'right'
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'paymentDate',
                        fields: [
                            {
                            },
                            {
                                type: 'date',
                                id: 'paymentDate',
                                label: 'invoice.form.paymentDate',
                                placeholder: 'invoice.form.paymentDate.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate']
                            },
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'message',
                        label: 'invoice.form.message',
                        placeholder: 'invoice.form.message.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'creditNoteCard.number.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'invoice.form.number.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'document.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'creditNote.customer',
                meta: {
                    type: 'form',
                    readOnly: true,
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'dualconnect',
                        id: 'customerId',
                        displayField: 'customerName',
                        label: 'invoice.form.customerName',
                        placeholder: 'invoice.form.customerName.placeholder',
                        modalTitle: 'invoice.form.customer.modal.title',
                        entity: 'contact',
                        entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                        valueMap: {
                            'customerName': 'name',
                            'customerId': 'id',
                            'customerEmail': 'email',
                            'customerAddress_city': 'address_city',
                            'customerAddress_postCode': 'address_postCode',
                            'customerAddress_street': 'address_street',
                            'customerCountry': 'country',
                            'customerCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId'
                        },
                        options: { withHeaders: false },
                        required: true,
                        showSubField: { field: 'companyTypeId', value: 'company' },
                        sub: {
                            id: 'contactPersonId',
                            displayField: 'contactPersonName',
                            placeholder: 'invoice.form.contactPerson.name.placeholder',
                            modalTitle: 'invoice.form.contactPerson.modal.title',
                            entity: 'contactPerson',
                            valueMap: {
                                'contactPersonName': 'name',
                                'contactPersonId': 'id',
                                'customerEmail': 'email'
                            }
                        }
                    },
                    {
                        type: 'email',
                        id: 'customerEmail',
                        label: 'invoice.form.customerEmail',
                        placeholder: 'invoice.form.customerEmail.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'customerAddress_street',
                        label: 'invoice.form.customerAddress',
                        placeholder: 'invoice.form.customerAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'customerAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'customerAddress_postCode',
                                placeholder: 'invoice.form.customerAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'customerAddress_city',
                                placeholder: 'invoice.form.customerAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            },

                        ]
                    },
                    {
                        type: 'country',
                        id: 'customerCountry',
                        displayField: 'customerCountryName',
                        placeholder: 'invoice.form.customerCountry',
                        valueMap: {
                            'customerCountry': 'id',
                            'customerCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    },

                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'creditNoteCard.customer.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'customerName',
                    emptyMessage: 'invoice.form.customer.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'creditNote.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'invoice.form.line.add.item',
                    width: '1200px',
                    menuTitle: 'all.form.line.menu',
                    menuItems: [
                        {
                            action: 'addLineDiscount',
                            label: 'all.form.line.discount.add',
                            condition: { field: 'discountType', operator: 'empty' }
                        },
                        {
                            action: 'removeLineDiscount',
                            label: 'all.form.line.discount.remove',
                            condition: { field: 'discountType', operator: 'notEmpty' }
                        }
                    ]
                },
                groups: [
                    {

                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'invoice.form.itemName',
                        placeholder: 'invoice.form.itemName.placeholder',
                        modalTitle: 'invoice.form.item.modal.title',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'itemType': 'type',
                            'netSalesPrice': 'netSalesPrice',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                            'itemTaxId': 'taxId',
                            'itemTaxName': 'taxName',
                            'itemTaxRate': 'taxRate'
                        },
                        nullDefaults: { itemTaxRate: 0 },
                        options: { withHeaders: true },
                        required: true,
                        conditionalFields: {
                            fields: ['itemTaxId', 'itemTaxName', 'itemTaxRate'],
                            condition: { field: 'customerCountry', operator: 'equals', valueFrom: 'profile.currentOrgCountry' }
                        }
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'invoice.form.itemDescription',
                        placeholder: 'invoice.form.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityNetSalesPrice',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'invoice.form.itemQuantity',
                                placeholder: 'invoice.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'invoice.form.netPrice',
                                placeholder: 'invoice.form.netPrice',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'price'
                            }
                        ]
                    },
                    /*
                     * Revealed by the line's own menu, which is what writes
                     * discountType. Both fields test the line rather than the
                     * document -- the scope B3 fixed -- so discounting one line
                     * does not put the fields on every other line.
                     */
                    {
                        type: 'group',
                        id: 'discountTypeDiscountValue',
                        condition: { field: 'discountType', operator: 'notEmpty' },
                        focus: false,
                        fields: [
                            {
                                type: 'switchSelect',
                                id: 'discountType',
                                displayField: 'discountTypeName',
                                label: 'all.form.line.discount.type',
                                entity: 'discountType',
                                valueMap: {
                                    'discountType': 'id',
                                    'discountTypeName': 'name'
                                }
                            },
                            {
                                type: 'number',
                                id: 'discountValue',
                                label: 'all.form.line.discount.value',
                                placeholder: 'all.form.line.discount.value.placeholder',
                                decimals: 2,
                                variant: 'price'
                            }
                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'creditNoteCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'creditNoteCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    // The currency rides with the figure rather
                                    // than dropping to its own line, which is
                                    // what makes room for the discount below.
                                    decorator: 'currency'
                                },
                                /*
                                 * What was taken off, under what was charged.
                                 * A percentage shows the rate and a fixed
                                 * discount shows the money, because those are
                                 * the two different things a reader wants back:
                                 * "(-10%)" or "(-1.000,00)".
                                 */
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.pct.display',
                                    mergeParams: ['discountValue'],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'percentage' }
                                },
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.amount.display',
                                    mergeParams: [{ type: 'amount', value: 'discountAmount' }],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'amount' }
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'creditNote.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent',
                    menuTitle: 'all.form.total.menu',
                    menuItems: [
                        {
                            action: 'addDocumentDiscount',
                            label: 'all.form.total.discount.add',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'empty' }
                        },
                        {
                            action: 'editDocumentDiscount',
                            label: 'all.form.total.discount.edit',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            action: 'removeDocumentDiscount',
                            label: 'all.form.total.discount.remove',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        }
                    ]
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'all.form.field.vatPct',
                            labelParams: [['vatTaxRate', 100], 'vatTaxableAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'creditNote.terms',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'textarea',
                        id: 'terms',
                        label: 'invoice.form.terms',
                        placeholder: 'invoice.form.terms.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'creditNoteCard.terms.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'terms',
                    emptyMessage: 'invoice.form.terms.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'invoice.form.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },

    invoiceCard: {
        entity: 'invoice',
        path: 'invoice',
        titleBar: { mergeParams: ['number'], new: 'invoice.form.new.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'invoiceCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'invoiceConfirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'invoiceConfirmBook',
                    modalPreflight: 'invoicePreBook'
                }
            ],
            actions: {
                book: { message: 'invoice.action.book.message' }
            }

        },
        width: '',
        afterSubmit: { navigateTo: '/sales/invoice' },
        fieldsLogic: ['paymentTermId', 'date', 'paymentDate', 'currency'],
        defaultData: [
            {
                id: 'font',
                defaultType: 'value',
                defaultValue: 'Courier',
            },
            {
                id: 'exchangeRate',
                defaultType: 'value',
                defaultValue: 1
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'invoice',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.payments',
                            action: 'showModal',
                            icon: 'money',
                            modalFormRef: 'invoicePayments'
                        },
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        },
                        {
                            type: 'modal',
                            title: 'invoice.form.mobile.panel.options',
                            action: 'showModal',
                            icon: 'gear',
                            modalFormRef: 'invoiceOptions'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'invoice.number',
                meta: {
                    type: 'form',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'invoice.form.number',
                                placeholder: 'invoice.form.number.placeholder',
                                entity: 'invoice',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'invoice.form.date',
                                placeholder: 'invoice.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate', 'exchangeRate', 'currency'],
                                align: 'right'
                            },
                        ]
                    },
                    {
                        type: 'group',
                        id: 'paymentTermIdDate',
                        fields: [
                            {
                                type: 'select',
                                id: 'paymentTermId',
                                displayField: 'paymentTermId',
                                label: 'invoice.form.paymentTerm',
                                entity: 'paymentTerm',
                                valueMap: {
                                    'paymentTermId': 'id',
                                    'paymentTermName': 'name',
                                    'paymentTermDays': 'days',
                                    'paymentSchedule': 'paymentSchedule',
                                    'paymentInstallments': 'installments',
                                    'paymentIntervalDays': 'intervalDays',
                                    'customPayments': 'customPayments'
                                },
                                nullDefaults: {
                                    'paymentSchedule': false,
                                    'paymentInstallments': 0,
                                    'paymentIntervalDays': 0,
                                    'customPayments': false
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate', 'numPayments', 'totalGrossSalesAmount', 'id', 'currency', 'exchangeRate', 'totalGrossSalesAmountBaseCurrency']
                            },
                            {
                                type: 'date',
                                id: 'paymentDate',
                                label: 'invoice.form.paymentDate',
                                placeholder: 'invoice.form.paymentDate.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['paymentTermId', 'date', 'paymentTermDays', 'paymentDate']
                            },
                        ]
                    },
                    {
                        type: 'textarea',
                        id: 'message',
                        label: 'invoice.form.message',
                        placeholder: 'invoice.form.message.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'invoiceCard.number.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'invoice.form.number.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'invoice.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoice.customer',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'dualconnect',
                        id: 'customerId',
                        displayField: 'customerName',
                        label: 'invoice.form.customerName',
                        placeholder: 'invoice.form.customerName.placeholder',
                        modalTitle: 'invoice.form.customer.modal.title',
                        entity: 'contact',
                        entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                        valueMap: {
                            'customerName': 'name',
                            'customerId': 'id',
                            'customerEmail': 'email',
                            'customerAddress_city': 'address_city',
                            'customerAddress_postCode': 'address_postCode',
                            'customerAddress_street': 'address_street',
                            'customerCountry': 'country',
                            'customerCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId',
                            'vatId': 'vatId',
                            'vatIdStatus': 'vatIdStatus',
                            'vatIdCheckedAt': 'vatIdCheckedAt',
                            'vatIdName': 'vatIdName',
                            'vatIdAddress': 'vatIdAddress',
                            'customerGroup': 'customerGroup',
                            'currency': 'currency',
                            'currencyName': 'currencyName',
                            'language': 'language',
                            'languageName': 'languageName',
                            'priceListId': 'priceListId',
                            'priceListName': 'priceListName'
                        },
                        // A customer without a VAT ID must not inherit the previous customer's check
                        nullDefaults: {
                            'vatId': '',
                            'vatIdStatus': 'unchecked',
                            'vatIdCheckedAt': null,
                            'vatIdName': null,
                            'vatIdAddress': null
                        },
                        options: { withHeaders: false },
                        required: true,
                        showSubField: { field: 'companyTypeId', value: 'company' },
                        sub: {
                            id: 'contactPersonId',
                            displayField: 'contactPersonName',
                            placeholder: 'invoice.form.contactPerson.name.placeholder',
                            modalTitle: 'invoice.form.contactPerson.modal.title',
                            entity: 'contactPerson',
                            valueMap: {
                                'contactPersonName': 'name',
                                'contactPersonId': 'id',
                                'customerEmail': 'email'
                            }
                        }
                    },
                    {
                        type: 'email',
                        id: 'customerEmail',
                        label: 'invoice.form.customerEmail',
                        placeholder: 'invoice.form.customerEmail.placeholder',
                        required: true
                    },
                    /*
                     * The customer's EU VAT ID and its VIES check. Reverse charge
                     * (0% EU) is the default, and can be booked, only when valid.
                     */
                    {
                        type: 'vatChecker',
                        id: 'vatId',
                        label: 'invoice.form.vatId',
                        placeholder: 'invoice.form.vatId.placeholder',
                        condition: { field: 'companyTypeId', operator: 'notEquals', value: 'person' }
                    },
                    {
                        type: 'text',
                        id: 'customerAddress_street',
                        label: 'invoice.form.customerAddress',
                        placeholder: 'invoice.form.customerAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'customerAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'customerAddress_postCode',
                                placeholder: 'invoice.form.customerAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'customerAddress_city',
                                placeholder: 'invoice.form.customerAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            },

                        ]
                    },
                    {
                        type: 'country',
                        id: 'customerCountry',
                        displayField: 'customerCountryName',
                        placeholder: 'invoice.form.customerCountry',
                        valueMap: {
                            'customerCountry': 'id',
                            'customerCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    },

                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'invoiceCard.customer.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'customerName',
                    emptyMessage: 'invoice.form.customer.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'invoice.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'invoice.form.line.add.item',
                    width: '1200px',
                    menuTitle: 'all.form.line.menu',
                    menuItems: [
                        {
                            action: 'addLineDiscount',
                            label: 'all.form.line.discount.add',
                            condition: { field: 'discountType', operator: 'empty' }
                        },
                        {
                            action: 'removeLineDiscount',
                            label: 'all.form.line.discount.remove',
                            condition: { field: 'discountType', operator: 'notEmpty' }
                        }
                    ]
                },
                groups: [
                    {

                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'invoice.form.itemName',
                        placeholder: 'invoice.form.itemName.placeholder',
                        modalTitle: 'invoice.form.item.modal.title',
                        entity: 'product',
                        entityParams: {
                            name: 'priceList',
                            fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                        },
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'itemType': 'type',
                            'netSalesPrice': 'netSalesPrice',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                            'itemTaxId': 'taxId',
                            'itemTaxName': 'taxName',
                            'itemTaxRate': 'taxRate'
                        },
                        nullDefaults: { itemTaxRate: 0 },
                        options: { withHeaders: true },
                        required: true,
                        conditionalFields: {
                            fields: ['itemTaxId', 'itemTaxName', 'itemTaxRate'],
                            condition: { field: 'customerCountry', operator: 'equals', valueFrom: 'profile.currentOrgCountry' }
                        },
                        linkedFields: ['currency', 'campaignId', 'customerGroupId', 'priceListId'],
                        manualEntry: true
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'invoice.form.itemDescription',
                        placeholder: 'invoice.form.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'netSalesPriceItemTaxId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'invoice.form.netPrice',
                                placeholder: 'invoice.form.netPrice',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'price'
                            },
                            {
                                type: 'select',
                                id: 'itemTaxId',
                                displayField: 'itemTaxName',
                                label: 'product.form.vatTax',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'vatTax',
                                entityParams: {
                                    type: 'query',
                                    params: [
                                        { key: 'scope', value: 'sales' },
                                        { key: 'recipientLocation', value: '${customerCountry}' },
                                        // The document date: the codes, and OSS from its registration date, as of then.
                                        { key: 'date', value: '${date}' },
                                        { key: 'companyType', value: '${companyTypeId}' },
                                        { key: 'productType', value: '${itemType}' },
                                        { key: 'requireValidVatId', value: 'true' },
                                        { key: 'vatIdStatus', value: '${vatIdStatus}' }
                                    ]
                                },
                                valueMap: {
                                    'itemTaxName': 'name',
                                    'itemTaxId': 'id',
                                    'itemTaxRate': 'rate',
                                    'itemTaxRequiresVatId': 'requiresVatId'
                                },
                                // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                                nullDefaults: { itemTaxRate: null },
                                options: { withHeaders: false },
                                required: true,
                                linkedFields: ['customerCountry', 'companyTypeId', 'vatIdStatus', 'date'],
                                lineLinkedFields: ['itemType']
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'invoice.form.itemQuantity',
                                placeholder: 'invoice.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'invoice.form.unitName',
                                placeholder: 'invoice.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },

                    /*
                     * Revealed by the line's own menu, which is what writes
                     * discountType. Both fields test the line rather than the
                     * document -- the scope B3 fixed -- so discounting one line
                     * does not put the fields on every other line.
                     */
                    {
                        type: 'group',
                        id: 'discountTypeDiscountValue',
                        condition: { field: 'discountType', operator: 'notEmpty' },
                        focus: false,
                        fields: [
                            {
                                type: 'switchSelect',
                                id: 'discountType',
                                displayField: 'discountTypeName',
                                label: 'all.form.line.discount.type',
                                entity: 'discountType',
                                valueMap: {
                                    'discountType': 'id',
                                    'discountTypeName': 'name'
                                }
                            },
                            {
                                type: 'number',
                                id: 'discountValue',
                                label: 'all.form.line.discount.value',
                                placeholder: 'all.form.line.discount.value.placeholder',
                                decimals: 2,
                                variant: 'price'
                            }
                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'invoiceCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'invoiceCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'invoice.form.product.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    // The currency rides with the figure rather
                                    // than dropping to its own line, which is
                                    // what makes room for the discount below.
                                    decorator: 'currency'
                                },
                                /*
                                 * What was taken off, under what was charged.
                                 * A percentage shows the rate and a fixed
                                 * discount shows the money, because those are
                                 * the two different things a reader wants back:
                                 * "(-10%)" or "(-1.000,00)".
                                 */
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.pct.display',
                                    mergeParams: ['discountValue'],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'percentage' }
                                },
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.amount.display',
                                    mergeParams: [{ type: 'amount', value: 'discountAmount' }],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'amount' }
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'invoice.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent',
                    menuTitle: 'all.form.total.menu',
                    menuItems: [
                        {
                            action: 'addDocumentDiscount',
                            label: 'all.form.total.discount.add',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'empty' }
                        },
                        {
                            action: 'editDocumentDiscount',
                            label: 'all.form.total.discount.edit',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            action: 'removeDocumentDiscount',
                            label: 'all.form.total.discount.remove',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        }
                    ]
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'all.form.field.vatPct',
                            labelParams: [['vatTaxRate', 100], 'vatTaxableAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'invoice.terms',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'textarea',
                        id: 'terms',
                        label: 'invoice.form.terms',
                        placeholder: 'invoice.form.terms.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'invoiceCard.terms.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'terms',
                    emptyMessage: 'invoice.form.terms.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'invoice.form.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },

    paymentTermCard: {
        entity: 'paymentTerm',
        path: 'paymentTerm',
        titleBar: { mergeParams: ['id'], new: 'paymentTerm.form.new.title' },
        cardTitle: {
            title: 'product.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'product.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'productConfirmDelete'

                },
                {
                    action: 'transact',
                    label: 'all.card.menu.transactions'
                },
                {
                    action: 'activate',
                    label: 'all.card.menu.activities'
                }

            ]
        },
        width: '756px',
        sections: [
            {
                id: 'paymentTerm',
                meta: {
                    type: 'form',
                    width: '480px'
                },
                groups: [
                    {
                        type: 'text',
                        id: 'id',
                        label: 'paymentTerm.form.id',
                        placeholder: 'paymentTerm.form.id.placeholder',
                        required: true,
                        autoComplete: 'paymentTermCode'
                    },
                    {
                        type: 'text',
                        id: 'name',
                        label: 'paymentTerm.form.name',
                        placeholder: 'paymentTerm.form.name.placeholder',
                        required: true,
                        autoComplete: 'paymentTermName'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'description',
                        id: 'daysDescription',
                        label: 'paymentTerm.form.days',
                        text: 'paymentTerm.form.days.description'
                    },

                    {
                        type: 'number',
                        id: 'days',
                        label: '',
                        placeholder: 'paymentTerm.form.days.placeholder',
                        required: true,
                        decimals: 0,
                        defaultType: 'value',
                        defaultValue: 14,

                        variant: 'quantity'
                    },
                    {
                        type: 'switch',
                        id: 'paymentSchedule',
                        switchText: 'Activate Schedule',
                    },
                    {
                        type: 'modal',
                        id: 'scheduleOptionsModal',
                        control: {
                            type: 'text',
                            id: 'ScheduleOptions',
                            label: 'paymentTerm.form.scheduleOptions',
                            placeholder: 'paymentTerm.form.options.placeholder'
                        },
                        descriptions: [
                            {
                                type: 'text',
                                text: 'paymentTerm.form.installments.label'
                            },
                            {
                                type: 'field',
                                field: 'installments'
                            }
                        ],
                        modalForm: {
                            id: 'paymentTermSchedule',
                            elements: [
                                {
                                    type: 'number',
                                    id: 'installments',
                                    label: 'paymentTerm.form.installments',
                                    placeholder: 'paymentTerm.form.installments.placeholder',
                                    required: true,
                                    decimals: 0,
                                    defaultType: 'value',
                                    defaultValue: 3,
                                    variant: 'quantity'
                                },
                                {
                                    type: 'number',
                                    id: 'intervalDays',
                                    label: 'paymentTerm.form.intervalDays',
                                    placeholder: 'paymentTerm.form.interval.placeholder',
                                    required: true,
                                    decimals: 0,
                                    defaultType: 'value',
                                    defaultValue: 30,
                                    variant: 'quantity'
                                },
                            ]
                        }
                    },

                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'paymentTermCard.paymentTerm.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'product.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ],
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} DKK',
                                    mergeParams: ['netSalesPrice'],
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '@${1}',
                                    mergeParams: ['unitName'],
                                    scale: 'normal'
                                },

                            ]
                        }
                    ]

                }
            },
        ]
    },

    priceListCard: {
        entity: 'priceList',
        path: 'priceList',
        titleBar: { mergeParams: ['idName'], new: 'priceList.form.new.title' },
        cardTitle: {
            title: 'priceList.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'priceListCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }

            ],
            menuItems: [
                {
                    action: 'updateItems',
                    label: 'priceList.form.button.generate',
                    icon: 'generateList',
                    variant: 'primary',
                    confirm: true,
                    modalConfig: 'priceListUpdateItems',
                    invalidateQuery: 'priceList/:id/priceListItem',

                    condition: { field: '$mode', operator: 'equals', value: 'edit' }
                },
                {
                    action: 'delete',
                    label: 'priceList.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        width: '1024px',
        afterSubmit: { stay: true },
        fieldsLogic: ['typeId', 'scopeId'],
        defaultData: [
            {
                id: 'exchangeRate',
                defaultType: 'value',
                defaultValue: 1
            }
        ],
        refresh: {
            updateItems: ['priceList/:id/priceListItem', 2000, 'product'],
        },
        sections: [
            {
                id: 'priceList',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'group',
                        id: 'typeIdId',
                        fields: [
                            {
                                type: 'switchSelect',
                                id: 'typeId',
                                displayField: 'typeName',
                                label: 'priceList.form.type',
                                placeholder: 'priceList.form.type.placeholder',
                                entity: 'priceType',
                                valueMap: {
                                    'typeName': 'name',
                                    'typeId': 'id'
                                },
                                options: { withHeaders: false },
                                required: true,
                                linkedFields: ['code', 'codeName', 'value', 'typeId']
                            },
                            {
                                type: "currency",
                                id: 'id',
                                displayField: 'id',
                                parameter: "date",
                                label: 'priceList.form.code.currency',
                                placeholder: 'priceList.form.code.placeholder',
                                modalTitle: "priceList.form.currency.modal.title",
                                entity: 'currency',
                                valueMap: {
                                    'currency': 'id',
                                    'currencyName': 'name',
                                    'exchangeRate': 'exchangeRate',
                                    'id': 'id',
                                    'idName': 'name',
                                    'baseCurrency': 'baseCurrency'
                                },
                                options: { withHeaders: false, displayId: true },
                                required: true,
                                // One field bound to `id`, rendered as three different
                                // controls depending on what the list is scoped to. The
                                // currency variant is the base because it is the only one
                                // carrying an exchange rate; the other two are deltas.
                                condition: { field: 'typeId', operator: 'in', value: ['currency', 'customerGroup', 'campaign'] },
                                conditionals: [
                                    {
                                        condition: { field: 'typeId', operator: 'equals', value: 'customerGroup' },
                                        set: {
                                            type: 'hconnect',
                                            label: 'priceList.form.code.customerGroup',
                                            placeholder: 'priceList.form.code.customerGroup.placeholder',
                                            entity: 'customerGroup',
                                            modalTitle: "priceList.form.customerGroup.modal.title",
                                            parentId: 'parentId',
                                            parentField: { field: 'type', value: 'normal' },
                                            valueMap: { 'id': 'id', 'idName': 'description' },
                                            options: { withHeaders: true },
                                        },
                                        unset: ['parameter']
                                    },
                                    {
                                        condition: { field: 'typeId', operator: 'equals', value: 'campaign' },
                                        set: {
                                            type: 'connect',
                                            label: 'priceList.form.code.campaign',
                                            placeholder: 'priceList.form.code.campaign.placeholder',
                                            entity: 'campaign',
                                            valueMap: { 'id': 'code', 'idName': 'name' },
                                            options: { withHeaders: true },
                                        },
                                        unset: ['parameter', 'modalTitle']
                                    }
                                ]
                            },
                        ]
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'group',
                        id: 'modeIdValue',
                        fields: [
                            {
                                type: 'switchSelect',
                                id: 'modeId',
                                displayField: 'modeName',
                                label: 'priceList.form.mode',
                                placeholder: 'priceList.form.mode.placeholder',
                                entity: 'priceMode',
                                valueMap: {
                                    'modeName': 'name',
                                    'modeId': 'id'
                                },
                                options: { withHeaders: false },
                                required: true,
                                condition: { field: 'typeId', operator: 'notEquals', value: 'currency' }
                            },
                            {
                                type: 'number',
                                id: 'value',
                                label: 'priceList.form.value',
                                placeholder: 'priceList.form.value.placeholder',
                                required: true,
                                decimals: 2,
                                condition: { field: 'typeId', operator: 'notEquals', value: 'currency' }
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'startEndDate',
                        fields: [
                            {
                                type: 'date',
                                id: 'startDate',
                                label: 'priceList.form.startDate',
                                condition: { field: 'typeId', operator: 'equals', value: 'campaign' }
                            },
                            {
                                type: 'date',
                                id: 'endDate',
                                label: 'priceList.form.endDate',
                                condition: { field: 'typeId', operator: 'equals', value: 'campaign' }
                            }
                        ]
                    },
                    {
                        type: "currency",
                        id: "currency",
                        displayField: "currency",
                        parameter: "date",
                        label: "priceList.form.currency",
                        placeholder: "priceList.form.currency.placeholder",
                        modalTitle: "priceList.form.currency.modal.title",
                        entity: "currency",
                        valueMap: {
                            currency: "id",
                            currencyName: "name",
                            exchangeRate: "exchangeRate",
                            baseCurrency: "baseCurrency"
                        },
                        options: { withHeaders: true, displayId: true },
                        required: true,
                        condition: { field: 'typeId', operator: 'notEquals', value: 'currency' }
                    },
                    {
                        type: 'switchSelect',
                        id: 'scopeId',
                        displayField: 'scopeName',
                        label: 'priceList.form.scope',
                        placeholder: 'priceList.form.scope.placeholder',
                        entity: 'priceScope',
                        valueMap: {
                            'scopeName': 'name',
                            'scopeId': 'id'
                        },
                        options: { withHeaders: false },
                        condition: { field: 'typeId', operator: 'notEquals', value: 'currency' }
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'priceListCard.priceList.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'id',
                    emptyMessage: 'priceList.form.code.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'idName',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2}',
                                    mergeParams: ['typeName', 'idName'],
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'merge',
                                    value: 'Code: ${1}',
                                    mergeParams: ['id'],
                                    scale: 'title'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    priceListItemCard: {
        entity: 'priceListItem',
        path: 'priceList/:id/priceListItem',
        titleBar: { mergeParams: ['name'], new: 'priceListItem.form.new.title' },
        cardTitle: {
            title: 'priceListItem.form.dropdown.toggle',
            menuItems: [
                {
                    action: 'delete',
                    label: 'priceListItem.form.dropdown.menu01',
                    confirm: true,
                    modalConfig: 'confirmDelete'
                }
            ]
        },
        sections: [
            {
                id: 'priceListItem',
                meta: {
                    type: 'form',
                    width: '1024px'
                },
                groups: [
                    {
                        type: 'text-readOnly',
                        id: 'name',
                        label: 'priceListItem.form.product',
                        displayType: 'text',
                    },
                    {
                        type: 'text-readOnly',
                        id: 'description',
                        label: 'priceListItem.form.description',
                        rows: 2,
                        displayType: 'text'
                    },
                    {
                        type: 'text-readOnly',
                        id: 'sku',
                        label: 'priceListItem.form.sku',
                        placeholder: 'priceListItem.form.sku.placeholder'
                    },
                    {
                        type: 'group',
                        id: 'originalNetSalesPrice',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'originalPrice',
                                label: 'priceListItem.form.originalPrice',
                                placeholder: 'priceListItem.form.originalPrice.placeholder',
                                displayType: 'amount'
                            },
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'priceListItem.form.netSalesPrice',
                                placeholder: 'priceListItem.form.netSalesPrice.placeholder',
                                required: true,
                                decimals: 5,
                                variant: 'price'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'unitNameCurrency',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'unitName',
                                label: 'priceListItem.form.unit',
                                placeholder: 'priceListItem.form.unit.placeholder',
                            },
                            {
                                type: "text-readOnly",
                                id: "currency",
                                label: "priceListItem.form.currency",
                                placeholder: "priceListItem.form.currency.placeholder",
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'taxName',
                        fields: [
                            {
                                type: 'text-readOnly',
                                id: 'taxName',
                                label: 'priceListItem.form.tax',
                                placeholder: 'priceListItem.form.tax.placeholder',
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'lockedExcluded',
                        fields: [
                            {
                                type: 'switch',
                                id: 'locked',
                                label: 'priceListItem.form.locked',
                                options: [
                                    { value: true, label: 'priceListItem.form.locked.yes' },
                                    { value: false, label: 'priceListItem.form.locked.no' }
                                ]
                            },
                            {
                                type: 'switch',
                                id: 'excluded',
                                label: 'priceListItem.form.excluded',
                                options: [
                                    { value: true, label: 'priceListItem.form.excluded.yes' },
                                    { value: false, label: 'priceListItem.form.excluded.no' }
                                ]
                            }
                        ]
                    }
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'priceListItemCard.priceListItem.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary',
                        invalidateQuery: 'priceList/all/priceListItem'
                    }
                ],
                displaySection: {
                    emptyField: 'name',
                    emptyMessage: 'priceListItem.form.name.missing.message',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'name',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'description',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesPrice',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '${1}',
                                    mergeParams: ['currency'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    quoteCard: {
        entity: 'quote',
        path: 'quote',
        titleBar: { mergeParams: ['number'], new: 'quote.form.new.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'quoteCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'delete',
                    label: 'all.confirm.delete.accept',
                    confirm: true,
                    modalConfig: 'quoteConfirmDelete'
                },
                {
                    action: 'book',
                    label: 'all.menu.item.book',
                    confirm: false,
                    preflight: true,
                    modalConfig: 'quoteConfirmBook',
                    modalPreflight: 'quotePreBook'
                }
            ],
            actions: {
                book: { message: 'quote.action.book.message' }
            }
        },
        width: '',
        afterSubmit: { navigateTo: '/sales/quote' },
        fieldsLogic: ['date', 'currency'],
        defaultData: [
            {
                id: 'font',
                defaultType: 'value',
                defaultValue: 'Courier',
            },
            {
                id: 'exchangeRate',
                defaultType: 'value',
                defaultValue: 1
            }
        ],
        mobilePanel: {
            sections: [
                {
                    type: 'actionButton',
                    id: 'actionButton',
                    title: 'all.form.button.preview',
                    entity: 'quote',
                    modalFormRef: 'documentPreview'
                },
                {
                    type: 'optionPanel',
                    id: 'optionPanel',
                    items: [
                        {
                            type: 'modal',
                            title: 'quote.form.mobile.panel.design',
                            action: 'showModal',
                            icon: 'design',
                            modalFormRef: 'invoiceDesign'
                        },
                        {
                            type: 'modal',
                            title: 'quote.form.mobile.panel.options',
                            action: 'showModal',
                            icon: 'gear',
                            modalFormRef: 'invoiceOptions'
                        }
                    ]
                }
            ]
        },
        sections: [
            {
                id: 'quote.number',
                meta: {
                    type: 'form',
                    width: '1200px',
                },
                groups: [
                    {
                        type: 'group',
                        id: 'numberDate',
                        fields: [
                            {
                                type: 'nserie',
                                id: 'number',
                                label: 'quote.form.number',
                                placeholder: 'quote.form.number.placeholder',
                                entity: 'quote',
                                required: true,
                                defaultType: 'nserie'
                            },
                            {
                                type: 'date',
                                id: 'date',
                                label: 'quote.form.date',
                                placeholder: 'quote.form.date.placeholder',
                                required: true,
                                defaultType: 'date',
                                linkedFields: ['exchangeRate', 'currency'],
                                align: 'right'
                            },
                        ]
                    },
                    {
                        type: 'date',
                        id: 'expiryDate',
                        label: 'quote.form.expiryDate',
                        placeholder: 'quote.form.expiryDate.placeholder',
                        required: false,
                        defaultType: 'date'
                    },
                    {
                        type: 'textarea',
                        id: 'message',
                        label: 'quote.form.message',
                        placeholder: 'quote.form.message.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'quoteCard.number.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'number',
                    emptyMessage: 'quote.form.number.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'number',
                                    scale: 'title',
                                    prefix: 'quote.form.number.title.prefix'
                                },
                                {
                                    type: 'date',
                                    value: 'date',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'quote.customer',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'dualconnect',
                        id: 'customerId',
                        displayField: 'customerName',
                        label: 'quote.form.customerName',
                        placeholder: 'quote.form.customerName.placeholder',
                        modalTitle: 'quote.form.customer.modal.title',
                        entity: 'contact',
                        entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                        valueMap: {
                            'customerName': 'name',
                            'customerId': 'id',
                            'customerEmail': 'email',
                            'customerAddress_city': 'address_city',
                            'customerAddress_postCode': 'address_postCode',
                            'customerAddress_street': 'address_street',
                            'customerCountry': 'country',
                            'customerCountryName': 'countryName',
                            'companyTypeId': 'companyTypeId',
                            'customerGroup': 'customerGroup',
                            'currency': 'currency',
                            'currencyName': 'currencyName',
                            'language': 'language',
                            'languageName': 'languageName',
                            'priceListId': 'priceListId',
                            'priceListName': 'priceListName'
                        },
                        options: { withHeaders: false },
                        required: true,
                        showSubField: { field: 'companyTypeId', value: 'company' },
                        sub: {
                            id: 'contactPersonId',
                            displayField: 'contactPersonName',
                            placeholder: 'quote.form.contactPerson.name.placeholder',
                            modalTitle: 'quote.form.contactPerson.modal.title',
                            entity: 'contactPerson',
                            valueMap: {
                                'contactPersonName': 'name',
                                'contactPersonId': 'id',
                                'customerEmail': 'email'
                            }
                        }
                    },
                    {
                        type: 'email',
                        id: 'customerEmail',
                        label: 'quote.form.customerEmail',
                        placeholder: 'quote.form.customerEmail.placeholder',
                        required: true
                    },
                    {
                        type: 'text',
                        id: 'customerAddress_street',
                        label: 'quote.form.customerAddress',
                        placeholder: 'quote.form.customerAddress.street',
                        autoComplete: 'address-line1'
                    },
                    {
                        type: 'group',
                        id: 'customerAddressPostCodeCity',
                        focus: false,
                        fields: [
                            {
                                type: 'text',
                                id: 'customerAddress_postCode',
                                placeholder: 'quote.form.customerAddress.postcode',
                                autoComplete: 'postal-code'
                            },
                            {
                                type: 'text',
                                id: 'customerAddress_city',
                                placeholder: 'quote.form.customerAddress.city',
                                focus: false,
                                autoComplete: 'address-level2'
                            },
                        ]
                    },
                    {
                        type: 'country',
                        id: 'customerCountry',
                        displayField: 'customerCountryName',
                        placeholder: 'quote.form.customerCountry',
                        valueMap: {
                            'customerCountry': 'id',
                            'customerCountryName': 'name',
                        },
                        defaultType: 'country',
                        fgMargin: '1.5rem'
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'quoteCard.customer.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'customerName',
                    emptyMessage: 'quote.form.customer.missing.message',
                    editButtonRightOffset: '10%',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'field',
                                    value: 'customerName',
                                    scale: 'title',
                                    icon: 'people'
                                },
                                {
                                    type: 'field',
                                    value: 'customerEmail',
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: '${1} - ${2} ${3} - ${4}',
                                    mergeParams: ['customerAddress_street', 'customerAddress_postCode', 'customerAddress_city', 'customerCountryName'],
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
            {
                id: 'quote.lines',
                meta: {
                    type: 'lines',
                    linesArray: 'lines',
                    linesAddAction: 'quote.form.line.add.item',
                    width: '1200px',
                    menuTitle: 'all.form.line.menu',
                    menuItems: [
                        {
                            action: 'addLineDiscount',
                            label: 'all.form.line.discount.add',
                            condition: { field: 'discountType', operator: 'empty' }
                        },
                        {
                            action: 'removeLineDiscount',
                            label: 'all.form.line.discount.remove',
                            condition: { field: 'discountType', operator: 'notEmpty' }
                        }
                    ]
                },
                groups: [
                    {
                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'quote.form.itemName',
                        placeholder: 'quote.form.itemName.placeholder',
                        modalTitle: 'quote.form.item.modal.title',
                        entity: 'product',
                        entityParams: {
                            name: 'priceList',
                            fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                        },
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemDescription': 'description',
                            'itemType': 'type',
                            'netSalesPrice': 'netSalesPrice',
                            'unitId': 'unitId',
                            'unitName': 'unitName',
                            'itemTaxId': 'taxId',
                            'itemTaxName': 'taxName',
                            'itemTaxRate': 'taxRate'
                        },
                        nullDefaults: { itemTaxRate: 0 },
                        options: { withHeaders: true },
                        required: true,
                        conditionalFields: {
                            fields: ['itemTaxId', 'itemTaxName', 'itemTaxRate'],
                            condition: { field: 'customerCountry', operator: 'equals', valueFrom: 'profile.currentOrgCountry' }
                        },
                        linkedFields: ['currency', 'campaignId', 'customerGroupId', 'priceListId']
                    },
                    {
                        type: 'textarea',
                        id: 'itemDescription',
                        label: 'quote.form.itemDescription',
                        placeholder: 'quote.form.itemDescription.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'netSalesPriceItemTaxId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'netSalesPrice',
                                label: 'quote.form.netPrice',
                                placeholder: 'quote.form.netPrice',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'price'
                            },
                            {
                                type: 'select',
                                id: 'itemTaxId',
                                displayField: 'itemTaxName',
                                label: 'product.form.vatTax',
                                placeholder: 'product.form.unitName.placeholder',
                                entity: 'vatTax',
                                entityParams: {
                                    type: 'query',
                                    params: [
                                        { key: 'scope', value: 'sales' },
                                        { key: 'recipientLocation', value: '${customerCountry}' },
                                        // The document date: the codes, and OSS from its registration date, as of then.
                                        { key: 'date', value: '${date}' },
                                        { key: 'companyType', value: '${companyTypeId}' },
                                        { key: 'productType', value: '${itemType}' }
                                    ]
                                },
                                valueMap: {
                                    'itemTaxName': 'name',
                                    'itemTaxId': 'id',
                                    'itemTaxRate': 'rate'
                                },
                                // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                                nullDefaults: { itemTaxRate: null },
                                options: { withHeaders: false },
                                required: true,
                                linkedFields: ['customerCountry', 'companyTypeId', 'date'],
                                lineLinkedFields: ['itemType']
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'itemQuantityUnitId',
                        focus: false,
                        fields: [
                            {
                                type: 'number',
                                id: 'itemQuantity',
                                label: 'quote.form.itemQuantity',
                                placeholder: 'quote.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'unitId',
                                displayField: 'unitName',
                                label: 'quote.form.unitName',
                                placeholder: 'quote.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'unitName': 'name',
                                    'unitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true
                            }
                        ]
                    },
                    /*
                     * Revealed by the line's own menu, which is what writes
                     * discountType. Both fields test the line rather than the
                     * document -- the scope B3 fixed -- so discounting one line
                     * does not put the fields on every other line.
                     */
                    {
                        type: 'group',
                        id: 'discountTypeDiscountValue',
                        condition: { field: 'discountType', operator: 'notEmpty' },
                        focus: false,
                        fields: [
                            {
                                type: 'switchSelect',
                                id: 'discountType',
                                displayField: 'discountTypeName',
                                label: 'all.form.line.discount.type',
                                entity: 'discountType',
                                valueMap: {
                                    'discountType': 'id',
                                    'discountTypeName': 'name'
                                }
                            },
                            {
                                type: 'number',
                                id: 'discountValue',
                                label: 'all.form.line.discount.value',
                                placeholder: 'all.form.line.discount.value.placeholder',
                                decimals: 2,
                                variant: 'price'
                            }
                        ]
                    },
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'quoteCard.lines.delete',
                        action: 'delete',
                        label: 'all.form.button.delete',
                        icon: 'delete',
                        variant: 'danger',
                        size: 'icon'
                    },
                    {
                        type: 'button',
                        id: 'quoteCard.lines.save',
                        action: 'save',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'itemName',
                    emptyMessage: 'quote.form.product.missing.message',
                    editButtonRightOffset: '25%',
                    columns: [
                        {
                            weight: 7,
                            basis: '70%',
                            elements: [
                                {
                                    type: 'merge',
                                    value: '${1} (x${2})',
                                    mergeParams: ['itemName', 'itemQuantity'],
                                    scale: 'title',
                                    icon: 'boxes'
                                },
                                {
                                    type: 'field',
                                    value: 'itemDescription',
                                    scale: 'normal'
                                }
                            ]
                        },
                        {
                            weight: 3,
                            basis: '30%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'amount',
                                    value: 'netSalesAmount',
                                    scale: 'title',
                                    // The currency rides with the figure rather
                                    // than dropping to its own line, which is
                                    // what makes room for the discount below.
                                    decorator: 'currency'
                                },
                                /*
                                 * What was taken off, under what was charged.
                                 * A percentage shows the rate and a fixed
                                 * discount shows the money, because those are
                                 * the two different things a reader wants back:
                                 * "(-10%)" or "(-1.000,00)".
                                 */
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.pct.display',
                                    mergeParams: ['discountValue'],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'percentage' }
                                },
                                {
                                    type: 'merge',
                                    value: 'all.form.line.discount.amount.display',
                                    mergeParams: [{ type: 'amount', value: 'discountAmount' }],
                                    scale: 'normal',
                                    condition: { field: 'discountType', operator: 'equals', value: 'amount' }
                                }
                            ],
                        }
                    ]
                }
            },
            {
                id: 'quote.summary',
                meta: {
                    type: 'totals',
                    collapsible: false,
                    width: '1200px',
                    align: 'end',
                    variant: 'transparent',
                    menuTitle: 'all.form.total.menu',
                    menuItems: [
                        {
                            action: 'addDocumentDiscount',
                            label: 'all.form.total.discount.add',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'empty' }
                        },
                        {
                            action: 'editDocumentDiscount',
                            label: 'all.form.total.discount.edit',
                            modalFormRef: 'documentDiscount',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            action: 'removeDocumentDiscount',
                            label: 'all.form.total.discount.remove',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        }
                    ]
                },
                displaySection: {
                    elements: [
                        {
                            type: 'line',
                            value: 'totalNetSalesAmountBeforeDiscount',
                            scale: 'normal',
                            label: 'invoice.form.subtotal',
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount.percentage',
                            // The multiplier form is what keeps this a bare 10
                            // rather than a formatted 10.00 -- the same idiom the
                            // VAT row uses to turn a rate into a percentage.
                            labelParams: [['documentDiscountValue', 1]],
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'percentage' }
                        },
                        {
                            type: 'line',
                            value: 'documentDiscountAmount',
                            scale: 'normal',
                            label: 'all.form.total.discount',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'equals', value: 'amount' }
                        },
                        {
                            type: 'line',
                            value: 'totalNetSalesAmount',
                            scale: 'normal',
                            label: 'all.form.total.taxable',
                            decorator: 'currency',
                            condition: { field: 'documentDiscountType', operator: 'notEmpty' }
                        },
                        {
                            type: 'array',
                            value: 'vatTaxAmount',
                            subEntity: 'vatTaxes',
                            scale: 'normal',
                            label: 'all.form.field.vatPct',
                            labelParams: [['vatTaxRate', 100], 'vatTaxableAmount'],
                            decorator: 'currency'
                        },
                        {
                            type: 'line',
                            value: 'totalGrossSalesAmount',
                            scale: 'large',
                            label: 'invoice.form.total',
                            decorator: 'currency'
                        }
                    ]
                }
            },
            {
                id: 'quote.terms',
                meta: {
                    type: 'form',
                    width: '1200px'
                },
                groups: [
                    {
                        type: 'textarea',
                        id: 'terms',
                        label: 'quote.form.terms',
                        placeholder: 'quote.form.terms.placeholder',
                    }
                ],
                buttons: [
                    {
                        type: 'button',
                        id: 'quoteCard.terms.close',
                        action: 'close',
                        label: 'all.form.button.save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'terms',
                    emptyMessage: 'quote.form.terms.missing.message',
                    columns: [
                        {
                            weight: 1,
                            basis: '100%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'quote.form.terms',
                                    scale: 'title'
                                },
                                {
                                    type: 'field',
                                    value: 'terms',
                                    scale: 'normal'
                                }
                            ]
                        }
                    ]
                }
            },
        ]
    },

    salesSettingsCard: {
        entity: 'salesSettings',
        path: 'salesSettings',
        titleBar: { label: 'sales.settings.heading', mergeParams: ['settingsType'], new: 'sales.settings.title' },
        cardTitle: {
            title: 'all.form.button.more',
            buttons: [
                {
                    type: 'submit',
                    id: 'salesSettingsCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ]
        },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            {
                id: 'salesSettings.VAT',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'yourTaxInformation',
                        label: 'sales.settings.vat.title',
                        text: 'sales.settings.vat.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'select',
                        id: 'defaultItemTaxId',
                        displayField: 'defaultItemTaxName',
                        label: 'sales.settings.vatTax',
                        placeholder: 'sales.settings.vatTax.placeholder',
                        entity: 'vatTax',
                        entityParams: {
                            type: 'query',
                            params: [
                                { key: 'scope', value: 'sales' }
                            ]
                        },
                        valueMap: {
                            'defaultItemTaxName': 'name',
                            'defaultItemTaxId': 'id',
                            'defaultItemTaxRate': 'rate'
                        },
                        // A code without a rate of its own (OSS) writes null, not the previous code's rate.
                        nullDefaults: { defaultItemTaxRate: null },
                        options: { withHeaders: false },
                        required: true
                    },
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'salesSettingsCard.VAT.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'defaultItemTaxId',
                    emptyMessage: 'sales.settings.vat.display.title',
                    columns: [
                        {
                            weight: 3,
                            basis: '30%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'sales.settings.vat.display.title',
                                    scale: 'title'
                                }
                            ],
                        },
                        {
                            weight: 7,
                            basis: '70%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'sales.settings.vat.display.rate',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: '${1}',
                                    mergeParams: ['defaultItemTaxName'],
                                    scale: 'normal'
                                },

                            ]
                        }
                    ]

                }
            },
            {
                id: 'salesSettings.invoice',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'invoiceSettings',
                        label: 'sales.settings.invoice.title',
                        text: 'sales.settings.invoice.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'select',
                        id: 'invoiceLanguage',
                        displayField: 'invoiceLanguage',
                        label: 'sales.settings.language',
                        placeholder: 'sales.settings.language.placeholder',
                        entity: 'language',
                        valueMap: {
                            'invoiceLanguageName': 'name',
                            'invoiceLanguage': 'id'
                        },
                        options: { withHeaders: false, displayId: true },
                        required: true,
                    },
                    {
                        type: 'select',
                        id: 'invoiceCurrency',
                        displayField: 'invoiceCurrency',
                        label: 'sales.settings.currency',
                        placeholder: 'sales.settings.currency.placeholder',
                        entity: 'currency',
                        valueMap: {
                            'invoiceCurrency': 'id',
                            'invoiceCurrencyName': 'name'
                        },
                        options: { withHeaders: false, displayId: true },
                        required: true,
                    },
                    {
                        type: 'select',
                        id: 'defaultPaymentTermId',
                        displayField: 'defaultPaymentTermId',
                        label: 'sales.settings.paymentTerm',
                        placeholder: 'sales.settings.paymentTerm.placeholder',
                        entity: 'paymentTerm',
                        valueMap: {
                            'defaultPaymentTermId': 'id',
                            'defaultPaymentTermName': 'name',
                            'defaultPaymentTermDays': 'days'
                        },
                        options: { withHeaders: false, displayId: true, edit: true, list: '/sales/paymentTerm' },
                        required: true,
                    },
                ],
                buttons: [
                    {
                        type: 'submit',
                        id: 'salesSettingsCard.invoice.save',
                        action: 'save',
                        label: 'all.form.button.update',
                        icon: 'save',
                        variant: 'primary'
                    }
                ],
                displaySection: {
                    emptyField: 'invoiceLanguage',
                    emptyMessage: 'sales.settings.invoice.display.title',
                    columns: [
                        {
                            weight: 3,
                            basis: '30%',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'sales.settings.invoice.display.title',
                                    scale: 'title'
                                }
                            ],
                        },
                        {
                            weight: 7,
                            basis: '70%',
                            align: 'end',
                            elements: [
                                {
                                    type: 'text',
                                    value: 'sales.settings.invoice.display.info',
                                    scale: 'title'
                                },
                                {
                                    type: 'merge',
                                    value: 'Language: ${1}',
                                    mergeParams: ['invoiceLanguage'],
                                    scale: 'normal'
                                },
                                {
                                    type: 'merge',
                                    value: 'Currency: ${1}',
                                    mergeParams: ['invoiceCurrency'],
                                    scale: 'normal'
                                },

                            ]
                        }
                    ]

                }
            },
            /*
             * The module's number series (37.03), one row per document type.
             * `numberSeries` is built by the server from the series counters on
             * every read, so "last used" and "next" are the counter's own. Saving
             * a new next number moves the counter; one already issued is refused.
             */
            {
                id: 'salesSettings.numberSeries',
                meta: {
                    type: 'lines',
                    linesArray: 'numberSeries',
                    showAddLine: false,
                    sectionTitle: 'settings.numberSeries.title',
                    width: '756px'
                },
                groups: [
                    { type: 'text-readOnly', id: 'format', label: 'settings.numberSeries.format' },
                    { type: 'text-readOnly', id: 'lastValue', label: 'settings.numberSeries.lastValue' },
                    { type: 'nserie', id: 'nextValue', label: 'settings.numberSeries.nextValue', placeholder: 'settings.numberSeries.nextValue.placeholder', required: true }
                ],
                buttons: [
                    { type: 'submit', id: 'salesSettingsCard.numberSeries.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'nextValue',
                    emptyMessage: 'settings.numberSeries.empty',
                    columns: [
                        {
                            weight: 6, basis: '60%',
                            elements: [
                                { type: 'merge', value: '${1}', mergeParams: [{ type: 'translate', value: 'labelKey' }], scale: 'title' },
                                { type: 'field', value: 'format', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 4, basis: '40%', align: 'end',
                            elements: [
                                { type: 'field', value: 'nextValue', scale: 'title', prefix: 'settings.numberSeries.next.prefix' },
                                { type: 'field', value: 'lastValue', scale: 'normal', prefix: 'settings.numberSeries.last.prefix', condition: { field: 'lastValue', operator: 'notEmpty' } }
                            ]
                        }
                    ]
                }
            }
        ]
    },
}
